"use strict";

exports.__esModule = true;
exports.initializeTagManager = void 0;

var _asyncLoader = require("../../helpers/asyncLoader");

function _settle(pact, state, value) {
  if (!pact.s) {
    if (value instanceof _Pact) {
      if (value.s) {
        if (state & 1) {
          state = value.s;
        }

        value = value.v;
      } else {
        value.o = _settle.bind(null, pact, state);
        return;
      }
    }

    if (value && value.then) {
      value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
      return;
    }

    pact.s = state;
    pact.v = value;
    const observer = pact.o;

    if (observer) {
      observer(pact);
    }
  }
}

/* eslint-disable */

/**
 * This loads a Tealium instance based on the parameters
 *
 * @param {*} profile
 * @param {*} environment
 * @returns
 */
const initializeTealium = function (profile, environment) {
  try {
    //to-do move to config
    window.utag_cfg_ovrd = {
      noview: true
    };
    window.utag_data = {};
    let tagManager;
    return Promise.resolve((0, _asyncLoader.asyncLoader)(`https://tags.tiqcdn.com/utag/corelio/${profile}/${environment}/utag.js`, 'tag-mgr', () => {
      tagManager = window.utag;
    })).then(function () {
      return tagManager;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
/* eslint-enable */

/* eslint-disable */

/**
 * This loads a GTM container based on the parameters
 * 
 * @param {*} gtmid
 * @returns
 *
 */


const _Pact = /*#__PURE__*/function () {
  function _Pact() {}

  _Pact.prototype.then = function (onFulfilled, onRejected) {
    const result = new _Pact();
    const state = this.s;

    if (state) {
      const callback = state & 1 ? onFulfilled : onRejected;

      if (callback) {
        try {
          _settle(result, 1, callback(this.v));
        } catch (e) {
          _settle(result, 2, e);
        }

        return result;
      } else {
        return this;
      }
    }

    this.o = function (_this) {
      try {
        const value = _this.v;

        if (_this.s & 1) {
          _settle(result, 1, onFulfilled ? onFulfilled(value) : value);
        } else if (onRejected) {
          _settle(result, 1, onRejected(value));
        } else {
          _settle(result, 2, value);
        }
      } catch (e) {
        _settle(result, 2, e);
      }
    };

    return result;
  };

  return _Pact;
}();

function _switch(discriminant, cases) {
  var dispatchIndex = -1;
  var awaitBody;

  outer: {
    for (var i = 0; i < cases.length; i++) {
      var test = cases[i][0];

      if (test) {
        var testValue = test();

        if (testValue && testValue.then) {
          break outer;
        }

        if (testValue === discriminant) {
          dispatchIndex = i;
          break;
        }
      } else {
        // Found the default case, set it as the pending dispatch case
        dispatchIndex = i;
      }
    }

    if (dispatchIndex !== -1) {
      do {
        var body = cases[dispatchIndex][1];

        while (!body) {
          dispatchIndex++;
          body = cases[dispatchIndex][1];
        }

        var result = body();

        if (result && result.then) {
          awaitBody = true;
          break outer;
        }

        var fallthroughCheck = cases[dispatchIndex][2];
        dispatchIndex++;
      } while (fallthroughCheck && !fallthroughCheck());

      return result;
    }
  }

  const pact = new _Pact();

  const reject = _settle.bind(null, pact, 2);

  (awaitBody ? result.then(_resumeAfterBody) : testValue.then(_resumeAfterTest)).then(void 0, reject);
  return pact;

  function _resumeAfterTest(value) {
    for (;;) {
      if (value === discriminant) {
        dispatchIndex = i;
        break;
      }

      if (++i === cases.length) {
        if (dispatchIndex !== -1) {
          break;
        } else {
          _settle(pact, 1, result);

          return;
        }
      }

      test = cases[i][0];

      if (test) {
        value = test();

        if (value && value.then) {
          value.then(_resumeAfterTest).then(void 0, reject);
          return;
        }
      } else {
        dispatchIndex = i;
      }
    }

    do {
      var body = cases[dispatchIndex][1];

      while (!body) {
        dispatchIndex++;
        body = cases[dispatchIndex][1];
      }

      var result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
        return;
      }

      var fallthroughCheck = cases[dispatchIndex][2];
      dispatchIndex++;
    } while (fallthroughCheck && !fallthroughCheck());

    _settle(pact, 1, result);
  }

  function _resumeAfterBody(result) {
    for (;;) {
      var fallthroughCheck = cases[dispatchIndex][2];

      if (!fallthroughCheck || fallthroughCheck()) {
        break;
      }

      dispatchIndex++;
      var body = cases[dispatchIndex][1];

      while (!body) {
        dispatchIndex++;
        body = cases[dispatchIndex][1];
      }

      result = body();

      if (result && result.then) {
        result.then(_resumeAfterBody).then(void 0, reject);
        return;
      }
    }

    _settle(pact, 1, result);
  }
}

const initializeGtm = function (gtmid) {
  try {
    //to-do move to config
    let tagManager; // Load the GTM script

    gtmScript(window, document, 'script', 'dataLayer', gtmid);
    tagManager = window.dataLayer;
    return Promise.resolve(tagManager);
  } catch (e) {
    return Promise.reject(e);
  }
};
/* eslint-enable */

/* eslint-disable */

/**
 * This is the script to load GTM - generated script from GTM
 * 
 * @param {*} w
 * @param {*} d
 * @param {*} s
 * @param {*} l
 * @param {*} i
 *
 */
// The GTM script needed to load GTM


function gtmScript(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
}
/* eslint-enable */


/**
* This function can be called to initialise a tag manager
* @todo add Gemius and others
*
* @param {} mhLogger
* @param {*} tagManager
* @returns
*/
const initializeTagManager = function (tagManager) {
  try {
    let _exit = false,
        _interrupt = false;
    let tagMgr; // console.log('initialize tagmanager - type = ' + tagManager.type);

    const _temp = _switch(tagManager.type, [[function () {
      return 'Tealium';
    }, function () {
      return Promise.resolve(initializeTealium(tagManager.profile, tagManager.environment, tagManager.type)).then(function (_initializeTealium) {
        tagMgr = _initializeTealium;
        _interrupt = true;
      });
    }], [function () {
      return 'Gtm';
    }, function () {
      return Promise.resolve(initializeGtm(tagManager.gtmid, tagManager.type, tagManager.environment)).then(function (_initializeGtm) {
        tagMgr = _initializeGtm;
        _interrupt = true;
      });
    }], [void 0, function () {
      throw new Error('no Tag Mgr found');
    }]]);

    return Promise.resolve(_temp && _temp.then ? _temp.then(function (_result) {
      return _exit ? _result : tagMgr;
    }) : _exit ? _temp : tagMgr);
  } catch (e) {
    return Promise.reject(e);
  }
};

exports.initializeTagManager = initializeTagManager;